import React from "react";
import {useLocation} from "react-router-dom";
import {useDispatch} from "react-redux";
import Header from "@/components/Global/Header/Header";
import NavigationParentItem from "../../NavigationParentItem/NavigationParentItem";
import NavigationChildItem from "../../NavigationChildItem/NavigationChildItem";
import {myAccountRoutes} from "@/constants/menuRoutes";
import {faSignOut} from "@fortawesome/pro-regular-svg-icons/faSignOut";
import {usePageTitle} from "@/hooks/usePageTitle/usePageTitle.js";

import {logout} from "@/features/auth";

export default function MyAccountNavigation() {
  const dispatch = useDispatch();
  const {pathname} = useLocation();

  const visibleRoutes = myAccountRoutes
    .filter(parentRoute => parentRoute.show)
    .map(parentRoute => {
      if (!parentRoute.subRoutes && parentRoute.show) {
        return parentRoute;
      }

      const childRoutes = parentRoute.subRoutes.filter(childRoute => childRoute.show);
      return {...parentRoute, subRoutes: childRoutes};
    });

  const currentRoute = visibleRoutes.find(route => route.path === pathname.replace("/my-account/", ""));
  usePageTitle(!currentRoute ? "My account" : currentRoute.title);

  const handleLogout = () => {
    dispatch(logout());
  };

  if (!currentRoute) {
    const routes = [
      ...visibleRoutes,
      {
        title: "Log out",
        icon: faSignOut,
        description: "Securely log out of the app",
        onButtonClick: handleLogout,
      },
    ];

    return (
      <>
        <Header variant="titleOnlyHeader">
          <h3 className="m-0">My Account</h3>
        </Header>
        <ul className="list-group">
          {routes.map(route => (
            <NavigationParentItem key={route.title} {...route} />
          ))}
        </ul>
      </>
    );
  }

  const {title, subRoutes} = currentRoute;
  return (
    <>
      <Header variant="titleOnlyHeader">
        <h3 className="m-0">{title}</h3>
      </Header>
      <ul className="list-group">
        {subRoutes.map(route => (
          <NavigationChildItem key={route.title} {...route} />
        ))}
      </ul>
    </>
  );
}
